import { Builder } from "@builder.io/react";
import bidrequest from "images/bidrequest.png";
import { toMutable } from "types/common";

const inputs = [
    {
        name: "title",
        type: "text",
        defaultValue: "Smart Bid Request Optimization",
        required: true,
    },
] as const;
const TrafficShapingComponentBlocks: BFC<typeof inputs> = ({ title }) => {
    return (
        <>
            <div className="component-wrapper mt-180">
                <div className="container ">
                    <div className="row justify-content-center text-center">
                        <div className="col">
                            <h2 className="mb-5">{title}</h2>
                            <img
                                loading="lazy"
                                src={bidrequest}
                                alt="Smart bid request optimization workflow showing real-time filtering of low-value programmatic traffic."
                                className="img-fluid"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
Builder.registerComponent(TrafficShapingComponentBlocks, {
    name: "TrafficShapingComponentBlocks",
    inputs: toMutable(inputs),
});
